"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _respondTo = _interopRequireDefault(require("../respondTo"));
var _createMixin = _interopRequireDefault(require("../utils/createMixin"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

/**
 * Responsive spacing mixin
 */
var _default = (0, _createMixin["default"])(function (theme, property, values) {
  return (0, _styledComponents.css)(["", ":", ";", " ", " ", ""], property, values.map(function (value) {
    if (value === 'auto') {
      return "".concat(value, " ");
    }
    if (value && value < 0) {
      return "-".concat(theme.spacing.responsive[Math.abs(value)].sm, "px ");
    }
    return "".concat(theme.spacing.responsive[value].sm, "px ");
  }), _respondTo["default"].md((0, _styledComponents.css)(["", ":", ";"], property, values.map(function (value) {
    if (value === 'auto') {
      return "".concat(value, " ");
    }
    if (value && value < 0) {
      return "-".concat(theme.spacing.responsive[Math.abs(value)].md, "px ");
    }
    return "".concat(theme.spacing.responsive[value].md, "px ");
  }))), _respondTo["default"].lg((0, _styledComponents.css)(["", ":", ";"], property, values.map(function (value) {
    if (value === 'auto') {
      return "".concat(value, " ");
    }
    if (value && value < 0) {
      return "-".concat(theme.spacing.responsive[Math.abs(value)].lg, "px ");
    }
    return "".concat(theme.spacing.responsive[value].lg, "px ");
  }))), _respondTo["default"].xl((0, _styledComponents.css)(["", ":", ";"], property, values.map(function (value) {
    if (value === 'auto') {
      return "".concat(value, " ");
    }
    if (value && value < 0) {
      return "-".concat(theme.spacing.responsive[Math.abs(value)].xl, "px ");
    }
    return "".concat(theme.spacing.responsive[value].xl, "px ");
  }))));
});
exports["default"] = _default;